import { ActionType } from '@mews-commander/enums';
import { OverlayedLoader } from '@mews-commander/ui';
import { lt, useToggle } from '@mews/framework';
import { IconName } from '@optimus-web/core';
import { HeadingAction } from '../../../legacy/React/Components/HeadingAction/Action/types';
import { BaseLayout } from '../BaseLayout';
import { FilterSidebarLayoutBaseProps } from './types';

/**
 * Layout for creating views with sidebar
 * @param props.loading - boolean flag to to show spinner overlay over the entire layout
 * @description Also takes ModalHeader props
 */
/** @deprecated Use NewFilterSidebarLayoutBase instead */
export const FilterSidebarLayoutBase = ({
    children,
    actions = [],
    loading,
    filterSidebarOpenedByDefault = true,
    withToggleFilterHeaderAction = true,
    padded = true,
    ...other
}: FilterSidebarLayoutBaseProps) => {
    const [showSidebar, toggleSidebar] = useToggle({ initialValue: filterSidebarOpenedByDefault });

    const toggleSidebarAction: HeadingAction = {
        type: ActionType.Custom,
        icon: IconName.Filter,
        text: lt('Filter'),
        onClick: toggleSidebar,
    };

    return (
        <BaseLayout
            actions={withToggleFilterHeaderAction ? [...actions, toggleSidebarAction] : [...actions]}
            padded={padded}
            {...other}
        >
            {children({ showSidebar, toggleSidebar })}
            <OverlayedLoader show={loading} />
        </BaseLayout>
    );
};
